module.exports = __webpack_public_path__ + "static/media/reportes.4589d332.svg";